export { default as Img200 } from './processed/200/scandal.jpg';
export { default as Img400 } from './processed/400/scandal.jpg';
export { default as Imgthumb } from './processed/thumb/scandal.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/scandal.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/scandal.jpg';
export const ImgData = { width: 1300, height: 755, ratio: 0.5807692307692308, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      226,
      44,
      36
    ],
    "_population": 238,
    "_hsl": [
      0.007017543859649123,
      0.7661290322580645,
      0.5137254901960784
    ]
  },
  "LightVibrant": {
    "_rgb": [
      228,
      156,
      140
    ],
    "_population": 1,
    "_hsl": [
      0.030303030303030304,
      0.6197183098591549,
      0.7215686274509805
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      115,
      32,
      24
    ],
    "_population": 187,
    "_hsl": [
      0.01465201465201465,
      0.6546762589928057,
      0.27254901960784317
    ]
  },
  "Muted": {
    "_rgb": [
      176,
      115,
      81
    ],
    "_population": 174,
    "_hsl": [
      0.059649122807017556,
      0.37549407114624506,
      0.503921568627451
    ]
  },
  "LightMuted": {
    "_rgb": [
      188,
      186,
      180
    ],
    "_population": 13,
    "_hsl": [
      0.12499999999999956,
      0.05633802816901409,
      0.7215686274509805
    ]
  },
  "DarkMuted": {
    "_rgb": [
      68,
      52,
      44
    ],
    "_population": 1,
    "_hsl": [
      0.05555555555555555,
      0.21428571428571427,
      0.2196078431372549
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/scandal.js